export default {"src":"/_next/static/media/apricots.be733c8d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};